import classNames from "classnames";
import { KeyboardKey } from "./KeyboardKey";

export declare namespace KeyboardCharacterKey {
  export interface Props {
    containerClassName?: string;
    className?: string;
    character: string;
    onClick: (() => void) | undefined;
  }
}

export function KeyboardCharacterKey({
  containerClassName,
  className,
  character,
  onClick,
}: KeyboardCharacterKey.Props) {
  return (
    <KeyboardKey
      containerClassName={classNames(containerClassName, "basis-9 md:basis-10")}
      className={className}
      text={character}
      onClick={onClick}
    />
  );
}
